import { features } from 'config/features.config';
import React, { Suspense, useMemo } from 'react';
import { Route, Routes } from 'react-router-dom';
import PagePlaceholder from '../PagePlaceholder/PagePlaceholder';
import PageNotFound from 'pages/page_notfound/PageNotFound';
import ProtectedRoute from 'auth/ProtectedRoute';

function MainRouter() {
  const routes = useMemo(() => buildRoutes(), []);

  function buildRoutes() {
    return features
      .sort((fa, fb) =>
        fb.route.path.length - fa.route.path.length ||
        fa.route.path.localeCompare(fb.route.path)
      )
      .map((feature) => {
        const DynamicElement = feature.route.element;
        return (
          <Route
            key={feature.route.path}
            path={feature.route.path}
            element={
              <ProtectedRoute
                requires={feature.requires}
                element={<DynamicElement />}
              />
            }
          />
        );
      });
  }

  return (
    <Suspense fallback={<PagePlaceholder />}>
      <Routes>
        {routes}
        <Route path="*" element={<PageNotFound />} />
      </Routes>
    </Suspense>
  );
}

export default MainRouter;
